import React from "react";
import { motion } from "framer-motion";

const BENEFITS = [
  {
    img: "/mockups/benefit_01_insurance.jpg",
    title: "Seguro sin costo el primer año",
    body: "Estrena con tranquilidad: cubrimos tu seguro amplio los primeros 12 meses en toda unidad HEBEH.",
  },
  {
    img: "/mockups/benefit_02_fuel.jpg",
    title: "Bonos de gasolina de bienvenida",
    body: "Cada compra incluye vales para que arranques con el tanque lleno y varias recargas por cuenta nuestra.",
  },
  {
    img: "/mockups/benefit_03_courtesy.jpg",
    title: "Auto de cortesía en servicios de agencia",
    body: "Cuando tu auto entra a mantenimiento programado, no te preocupes: te prestamos un vehículo mientras el tuyo está en revisión. Beneficio válido durante el primer año.",
  },
];

export default function BenefitsSection() {
  return (
    <section
      className="relative bg-white text-[#0B1623] py-20 md:py-28"
      data-testid="benefits-section"
      aria-label="Beneficios exclusivos"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-12 md:mb-16">
          <span className="font-rajdhani font-medium text-[#3B82F6] text-xs md:text-sm tracking-[0.4em] uppercase">
            Beneficios incluidos
          </span>
          <h2 className="font-rajdhani font-semibold text-[#0B1623] tracking-tight leading-[0.95] text-3xl sm:text-4xl md:text-5xl mt-4">
            Va más allá del auto.
          </h2>
          <p className="font-manrope text-[#0B1623]/65 text-base md:text-lg mt-4 max-w-2xl">
            Con HEBEH no compras nada más un vehículo — te llevas también tranquilidad,
            gasolina y respaldo cuando más lo necesitas.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {BENEFITS.map((b, i) => (
            <motion.article
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.1, ease: [0.25, 0.1, 0.25, 1] }}
              className="group relative rounded-2xl overflow-hidden bg-[#0B1623] shadow-[0_10px_40px_rgba(11,22,35,0.10)] hover:shadow-[0_28px_70px_rgba(11,22,35,0.18)] transition-shadow duration-500"
              data-testid={`benefit-card-${i + 1}`}
            >
              {/* Full-height background image */}
              <div className="relative aspect-[4/5] overflow-hidden">
                <img
                  src={b.img}
                  alt={b.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.25,0.1,0.25,1)] group-hover:scale-[1.06]"
                  loading="lazy"
                />
                {/* Bottom-to-top dark gradient for text legibility */}
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B1623] via-[#0B1623]/70 to-transparent" />

                {/* Number badge top-left */}
                <div className="absolute top-5 left-5">
                  <span className="font-rajdhani font-medium text-white/50 text-xs tracking-[0.35em] uppercase">
                    0{i + 1} / Beneficio
                  </span>
                </div>

                {/* Content bottom */}
                <div className="absolute inset-x-0 bottom-0 p-7 md:p-8">
                  <h3 className="font-rajdhani font-semibold text-white text-2xl md:text-[26px] leading-[1.15] tracking-tight text-shadow-lg">
                    {b.title}
                  </h3>
                  <p className="font-manrope text-white/80 mt-3 leading-relaxed text-sm md:text-[15px]">
                    {b.body}
                  </p>
                  <div className="mt-5 h-[2px] w-10 bg-[#3B82F6] group-hover:w-20 transition-all duration-500" />
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
